import React, { useState, useEffect, useMemo } from 'react';
import Banner from '../../assets/img/banner-web.jpg'
import '../../styles/HeroSection.css'

const HeroSection = () => {
    const words = useMemo(() => ["Aplicaciones Web", "Landing Page", "Mejoras de funcionalidades", "Proyectos personalizados"], []);
    const [displayedText, setDisplayedText] = useState("");
    const [wordIndex, setWordIndex] = useState(0);
    const [letterIndex, setLetterIndex] = useState(0);

    useEffect(() => {
        const currentWord = words[wordIndex];

        const typingInterval = setInterval(() => {
            setDisplayedText((prev) => prev + currentWord[letterIndex]);
            setLetterIndex((prev) => prev + 1);
        }, 150);

        if (letterIndex === currentWord.length) {
            clearInterval(typingInterval);
            setTimeout(() => {
                setLetterIndex(0);
                setDisplayedText("");
                setWordIndex((prev) => (prev + 1) % words.length);
            }, 1000);
        }

        return () => clearInterval(typingInterval);
    }, [letterIndex, wordIndex, words]);

    return (
        <section id="home" className="hero section dark-background">
            <img src={Banner} alt="" data-aos="fade-in" className=""></img>
            <div className="container" data-aos="fade-up" data-aos-delay="100">
                <h2 className='highlight-border'>
                    Stack<span className="highlight">Coding</span>
                </h2>
                <p>
                    Te ofrecemos soluciones para: <span className="typed">{displayedText}</span>
                    <span className="typed-cursor typed-cursor--blink" aria-hidden="true">|</span>
                </p>
            </div>
        </section>
    )
}

export default HeroSection